import React, { useState, useEffect } from 'react'
import { Box, Paper, Modal } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import ReactGA from 'react-ga4'
import { tracker } from '../../analytics'
import {
  setSelectedCitation
} from '../../redux/actions/documentAction'
import { clearSearchDocument, setSearchDocument, setSearchIsModalMobileVisible, setFilterModalOpen } from '../../redux/actions/searchAction'
import SearchLandingView from './components/SearchLandingView'
import SearchResultsView from './components/SearchResultsView'
import PreSearchFilterModal from './components/PreSearchFilterModal'
import DocumentViewer from '../../components/document-viewer/DocumentViewer'
import { PdfFocusProvider } from '../../components/pdf-viewer/pdfContext'
import TutorialModal from '../../components/TutorialModal'
import { useSearchTokens } from './searchDesignTokens'

const SearchScreen = () => {
  const dispatch = useDispatch()
  const dk = useSearchTokens()

  // Redux state
  const open = useSelector(state => state.navbar.isOpen)
  const searchDocumentSourceUrl = useSelector(state => state.search.searchDocumentSourceUrl)
  const searchSelectedCitation = useSelector(state => state.search.searchSelectedCitation)
  const searchDocument = useSelector(state => state.search.searchDocument)
  const isSearchLoadingDocument = useSelector(state => state.search.isSearchLoadingDocument)
  const isSearchModalVisible = useSelector(state => state.search.isSearchModalVisible)
  const totalResultCount = useSelector(state => state.search.totalResultCount)
  const hadResults = useSelector(state => state.search.hadResults)
  const filterModalOpen = useSelector(state => state.search.filterModalOpen)

  console.log('[SearchScreen] render', {
    citationId: searchSelectedCitation?.id,
    section_title: searchSelectedCitation?.metadata?.section_title,
    searchDocId: searchDocument?.id,
    isSearchLoadingDocument,
  })

  // Local state
  const [searchVideoModalOpen, setSearchVideoModalOpen] = useState(false)
  const [mode, setMode] = useState('law')

  const hasSearchResults = hadResults || totalResultCount > 0

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: '/search',
      title: 'Search Screen'
    })
  }, [])

  // Handlers
  const handleCloseModal = () => {
    dispatch(setSearchIsModalMobileVisible(false))
    dispatch(setSelectedCitation(null))
  }

  const handleClearSearch = () => {
    dispatch(clearSearchDocument())
  }

  const handleOpenVideoModal = () => setSearchVideoModalOpen(true)

  return (
    <PdfFocusProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          backgroundColor: dk.bg,
          overflow: 'hidden',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            boxShadow: dk.shadow,
            backgroundColor: dk.surface,
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {!hasSearchResults ? (
            <SearchLandingView
              mode={mode}
              setMode={setMode}
              onOpenVideoModal={handleOpenVideoModal}
            />
          ) : (
            <SearchResultsView
              mode={mode}
              setMode={setMode}
              onOpenVideoModal={handleOpenVideoModal}
              totalResultCount={totalResultCount}
              onClearSearch={handleClearSearch}
              searchDocument={searchDocument}
              isSearchLoadingDocument={isSearchLoadingDocument}
              searchDocumentSourceUrl={searchDocumentSourceUrl}
              searchSelectedCitation={searchSelectedCitation}
            />
          )}

          {/* Mobile Modal */}
          <Modal
            open={isSearchModalVisible}
            onClose={handleCloseModal}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Box
              sx={{
                width: '90%',
                height: '80vh',
                backgroundColor: dk.elevated,
                padding: '16px',
                borderRadius: '16px',
                border: `1px solid ${dk.border}`,
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <DocumentViewer
                document={searchDocument}
                isLoadingDocument={isSearchLoadingDocument}
                documentSourceUrl={searchDocumentSourceUrl}
                selectedCitation={searchSelectedCitation}
                setDocument={setSearchDocument}
              />
            </Box>
          </Modal>

          {/* Pre-Search Filter Modal */}
          <PreSearchFilterModal
            open={filterModalOpen}
            onClose={() => dispatch(setFilterModalOpen(false))}
            mode={mode}
            setMode={setMode}
          />

          {/* Search Tutorial Video Modal */}
          <TutorialModal
            open={searchVideoModalOpen}
            onClose={() => setSearchVideoModalOpen(false)}
            defaultTab="search"
          />
        </Paper>
      </Box>
    </PdfFocusProvider>
  )
}

export default SearchScreen
